
import { AUTH_API_URL } from "config/api";
import { showApiError } from "config/apiToast";
import React, { useState, useEffect } from 'react';
import "./verificationemail.scss";
import { useHistory } from 'react-router-dom';
import axios from 'axios';
const Verificationemail = () => {

    const history = useHistory();
    const [token, settoken] = useState(null);
    const [reduxtabb, setreduxtabb] = useState(null);

    // const [orders, setOrders] = useState([]);
    // const currencyPair = 'ethusd';

    // const currencyArray = currencyPair.toUpperCase().match(/.{1,3}/g);
    // const apiurl = Environment?.api_url
    const [password, setpassword] = useState(null)
    const [errorpassowrd, seterrorpassowrd] = useState('')

    const Verify = () => {
        ValidFeilds();
        if (password != '' && password != null) {
            const config = {
                method: 'post',
                url: `${AUTH_API_URL}/verifications/otp-code`,
                data: {
                    channel: "email",
                    operation: "login",
                    otpCode: parseInt(password),
                    userId : parseInt(token),
                    rememberMe: true
                },
            };
            axios(config)
                .then(function (res) {
                    // setLoader(false)
                    // toast.success("User Signup in Successfully");
                    // router.push('/emailverifaction')
                    if (res) {

                        // toast.success("Verifition Successfull");
                        const token = res?.data?.accessToken;
                        const refreshtoken = res?.data?.refreshToken;
                        localStorage.setItem("refreshTokenDash", refreshtoken);
                        localStorage.setItem("accessTokenDash", token);
                        history.push('/admin/dashboard')

                        // console.log("res get here",res)
                        // const token = res?.data?.data?.accessToken;
                        // localStorage.setItem("accessToken", token);
                        // GetUser();
                        // setChangeAccount(token);
                    }
                    // router.push(`/putonsale?id=${Id}`)
                    // props?.GetBidDetail()
                    // history.push(`/explore`);
                })
                .catch(function (error) {
                  const messages = showApiError(error);
                  seterrorpassowrd(messages.join(" "));
                });
        }
    };

    const ValidFeilds = () => {
        if (password === null || password === '') {
            seterrorpassowrd('Verification Code is required')
        }
        else {
            seterrorpassowrd(null)
        }
    }

    const Handleemail = (e) => {
        setpassword(e)
        if (e === null || e === '') {
            seterrorpassowrd('Verification Code is required')
        }
        else {
            seterrorpassowrd('')
        }
    }

    useEffect(() => {
        const userid = localStorage.getItem('UseridDash');
        if (userid) {
            settoken(userid)
        }
    }, []);

    return (
        <>

            <section className='main-login'>
                <img src="\assets\signupshade.png" alt="loginshade" className="loginshade" />
                <div className='container-fluid p-0'>
                    <div className='row'>
                        <div className='col-sm-6 p-0'>
                            <div className='leftbackground'>
                                <div className='leftimage'>
                                    <img src='\assets\laptop.png' alt='img' className='img-fluid' />
                                </div>
                                <div className='mainhead'>
                                    <h3>Verify your email address for login</h3>
                                    <p>Enjoy the world’s largest cryptocurrency exchange at your fingertips.</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-6 p-0'>
                            <div className='rightbackground'>
                                <div className="rightmain">
                                    <div className='rightbackground'>
                                        <div className='mainhead'>
                                            <h3>Email Verification</h3>
                                            <p>Please enter the 6-digit verification code sent to <span className='asdasdasasdasdasads'>queckosendgridtester@gmail.com</span>. the code is valid for 30 minutes.</p>
                                        </div>
                                        <div className='three'>
                                            <p className="uppertext">Email verification code</p>
                                            <input type="number" onChange={(e) => Handleemail(e.target.value)} placeholder='Enter code' className='emailpaddright' />
                                            <p className='danger'>{errorpassowrd ? errorpassowrd : ''}</p>
                                            {/* <p className="righttext">Code Sent</p> */}
                                        </div>
                                        {/* <div className='notrecieve'>d
                                            <p>Does not receive a code?</p>
                                            <h6>Resend Code</h6>
                                        </div> */}
                                        <button onClick={Verify} className={errorpassowrd === '' ? 'common-btn' : 'common-btn sgreeee'}>Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}

export default Verificationemail
